import { createContext, useContext, useLayoutEffect, type Dispatch, type SetStateAction } from "react";

export type MobileBack = { pathname: string; action: () => void };
export const MobileNavigation = createContext<Dispatch<SetStateAction<MobileBack | null>> | null>(null);

/** Let the active screen supply its explicit return destination to the shell toolbar. */
export function useMobileBack(pathname: string, action: (() => void) | null) {
  const setBack = useContext(MobileNavigation);
  useLayoutEffect(() => {
    if (!setBack || !action) return;
    const entry = { pathname, action };
    setBack(entry);
    return () => setBack(current => current === entry ? null : current);
  }, [setBack, pathname, action]);
}
